export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const STAGES = [
  { id: 'whitebox', n: 1, label: 'Maquette blanche', short: 'Maquette', engine: 'Sans IA · 0 crédit', hint: 'Extrusion mathématique du plan tracé' },
  { id: 'textured', n: 2, label: 'Texturer', short: 'Texturé', engine: 'IA · 1 crédit', hint: 'Matériaux de la Matériauthèque sur la maquette ancrée' },
  { id: 'furnished', n: 3, label: 'Meubler', short: 'Meublé', engine: 'IA · 1 crédit', hint: 'Mobilier retenu sur le rendu texturé ancré' },
  { id: 'final', n: 4, label: 'Ambiance (optionnel)', short: 'Ambiance', engine: 'IA · 1 crédit', hint: 'Variante lumière (Golden Hour, nuit, midi) sur le rendu meublé — le livrable reste l’étape 3 validée', optional: true },
];

export const STATUS_META = {
  todo: { label: 'Non commencé', color: 'rgba(255,255,255,0.35)', bg: 'rgba(255,255,255,0.06)' },
  in_progress: { label: 'En cours', color: '#93C5FD', bg: 'rgba(147,197,253,0.14)' },
  rendered: { label: 'Rendu — à ancrer', color: '#FDE68A', bg: 'rgba(253,230,138,0.14)' },
  anchored: { label: 'Référence ancrée', color: '#F5C77E', bg: 'rgba(217,160,91,0.18)' },
  validated: { label: 'Validé', color: '#86EFAC', bg: 'rgba(134,239,172,0.14)' },
};

export const fullImg = (url) => (url && url.startsWith('/') ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url);
export const lotLabel = (lot) => (lot ? `${lot.lot_number || lot.name || lot.lot_id}${lot.typology ? ` · ${lot.typology}` : ''}` : '');

export const ENGINES = [
  { id: 'nano_banana', label: 'Nano Banana Pro', vendor: 'Google · Gemini 3 Pro Image', hint: 'Respect fort de la maquette, détails fins (défaut)' },
  { id: 'gpt_image_1', label: 'GPT Image 1', vendor: 'OpenAI · édition image-to-image', hint: 'Matières très photoréalistes, parfois recadre' },
];
